<template>
  <div class="h-full flex" v-loading="pageLoading">
    <el-card class="h-full w-300px mr-10px">
      <div slot="header">
        {{ $t('租户') }}
      </div>
      <el-tree
        v-loading="tenantTreeLoading"
        class="h-9/10 p-10px overflow-auto"
        default-expand-all
        :data="tenantTree"
        node-key="id"
        :highlight-current="true"
        :props="tenantTreeProps"
        @node-click="menuTreeClick"
        ref="tenantTree"
      >
      </el-tree>
      <div
        class="absolute inset-0 cursor-pointer"
        @click="triggerModal"
        v-if="menuTreeLoading"
      ></div>
    </el-card>
    <el-card class="h-full relative  flex-1">
      <div slot="header" class="flex items-center justify-between">
        <span>{{ $t('分配菜单') }}</span>
        <div>
          <span class="mr-10px"
            ><i class="iconfont icon-bg-delete mr-5px text-color-system"></i
            ><span class="text-14px text-color-secondary">已失效</span></span
          >
        </div>
        <el-button
          type="primary"
          size="mini"
          class="float-right"
          v-if="$hasAccess('update')"
          @click="distributeMenu"
          >{{ $t('保存') }}</el-button
        >
      </div>
      <el-tree
        class="h-9/10 p-10px overflow-auto"
        default-expand-all
        v-loading="menuTreeLoading"
        :data="checkedTreedata"
        node-key="menuKey"
        show-checkbox
        ref="menuTree"
        draggable
        :props="menuTreeProps"
      >
        <div slot-scope="{ node, data }" class="w-full">
          <span :class="data.icon" class="mr-5px"></span>
          <span>{{ data.meta.title }}</span>
          <span v-if="data.originMeta && data.meta.title !== data.originMeta.title">
            (<span class="text-blue-500">{{ data.originMeta.title }}</span
            >)</span
          >
          <i
            v-if="data.metaMenuIsDeleted"
            class="iconfont icon-bg-delete ml-5px mr-5px text-color-system"
          ></i>
          <el-dropdown v-if="$hasAccess('update')" class="float-right">
            <span class="el-dropdown-link">
              <i class="iconfont icon-line-moreVertical text-14px font-bold"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native.stop="operateTenantMenu(data)">{{
                $t('编辑')
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-tree>
    </el-card>
    <operateTenantMenuComponent
      :operateTenantDialog="operateTenantDialog"
      :operateMenuForm="operateMenuForm"
      @refreshTenantMenu="refreshTenantMenu"
      @closeOperateTenantDialog="closeOperateTenantDialog"
      @refreshHomeMenuData="refreshHomeMenuData"
      v-if="showOperateTenantMenu"
    />
  </div>
</template>
<script>
import { TenantApi } from '@wiz-api/abp-tenant-management'
import { MenuApi } from '@wiz-api/eaf-menu-management'
import { TenantMenuApi } from '@wiz-api/eaf-tenant-management'
import { cloneDeep, forEach, isEmpty, isNil, find, filter } from 'lodash'

const operateTenantMenuComponent = () => {
  return import('../components/OperateTenantMenu')
}
const tenantApiService = new TenantApi()
const menuApiService = new MenuApi()
const tenantMenuApiService = new TenantMenuApi()
export default {
  name: 'tenant-menu',
  components: {
    operateTenantMenuComponent,
  },
  data() {
    return {
      pageLoading: false,
      currentTenantId: '', // 当前租户id
      currentMenu: null, // 当前编辑菜单
      showOperateTenantMenu: false,
      menuTreeLoading: false,
      tenantTreeLoading: false,
      currentTenant: null, // 当前选中租户
      tenantTree: [],
      menuTree: [],
      checkedTreedata: [], // 选中的菜单树
      tenantTreeProps: {
        label: 'name',
        children: 'children',
      },
      menuTreeProps: {
        children: 'children',
        disabled: (data) => {
          return data.flag === 4 || data.isDefine // 超管菜单和租户新增菜单默认置灰
        },
      },
      checkedMenuKeys: [],
      operateTenantDialog: {
        visible: false,
      },
      operateMenuForm: {
        title: '',
        icon: '',
        isShowCheckBox: false,
        isHomeMenu: false,
      },
    }
  },
  methods: {
    refreshHomeMenuData(data) {
      this.refreshCheckedTreedata(data, this.checkedTreedata)
    },
    refreshCheckedTreedata(data, arr) {
      _.forEach(arr, (item) => {
        if (item.children && item.children.length) {
          this.refreshCheckedTreedata(data, item.children)
        } else if (item.meta.title === data.title) {
          item.meta.isHomeMenu = data.isHomeMenu
        } else {
          item.meta.isHomeMenu = false
        }
      })
    },
    triggerModal() {
      // 触发遮罩层
      this.$message.warning('租户菜单数据正在加载中')
    },
    menuTreeAssignAllocation(treeData, checkedMenuKeys, halfCheckedMenukeys) {
      // 将勾选的菜单赋值allocationNumber, 0-没勾选 1-勾选 2-半勾选
      forEach(treeData, (treeItem) => {
        treeItem.allocationNumber = 0
        if (checkedMenuKeys.includes(treeItem.menuKey)) {
          treeItem.allocationNumber = 1
        } else if (halfCheckedMenukeys.includes(treeItem.menuKey)) {
          treeItem.allocationNumber = 2
        }
        if (!isEmpty(treeItem.children)) {
          this.menuTreeAssignAllocation(treeItem.children, checkedMenuKeys, halfCheckedMenukeys)
        }
      })
    },
    distributeMenu() {
      this.$confirm(
        this.$t(`确认要将勾选菜单分配给租户${this.currentTenant.name}么?`),
        this.$t('提示'),
        {
          confirmButtonText: this.$t('确认'),
          cancelButtonText: this.$t('取消'),
          type: 'warning',
        }
      ).then(async () => {
        this.pageLoading = true
        const checkedMenuKeys = this.$refs.menuTree.getCheckedKeys()
        const halfCheckedMenukeys = this.$refs.menuTree.getHalfCheckedKeys()
        this.menuTreeAssignAllocation(this.checkedTreedata, checkedMenuKeys, halfCheckedMenukeys)
        const [err, res] = await tenantMenuApiService.updateTenantMenuUnionMenuSortTree({
          tenantId: this.currentTenant.id,
          body: this.checkedTreedata,
        })
        this.pageLoading = false
        if (!err) {
          this.$message.success(this.$t('分配成功'))
        }
      })
    },
    refreshTenantMenu(data) {
      // 确认修改租户菜单
      this.currentMenu.icon = data.icon
      this.currentMenu.meta.title = data.title
      this.currentMenu.meta.isHomeMenu = data.isHomeMenu
      this.operateTenantDialog.visible = false
    },
    closeOperateTenantDialog(data) {
      // 关闭编辑租户弹窗
      this.operateTenantDialog.visible = false
    },
    operateTenantMenu(menu) {
      // 编辑租户菜单
      this.currentMenu = menu
      this.showOperateTenantMenu = true
      this.operateMenuForm.title = menu.meta.title
      this.operateMenuForm.icon = menu.icon
      this.operateMenuForm.menuKey = menu.menuKey
      this.operateMenuForm.isHomeMenu = menu.meta.isHomeMenu
      if (menu.children && menu.children.length) {
        this.operateMenuForm.isShowCheckBox = false
      } else {
        this.operateMenuForm.isShowCheckBox = true
      }
      this.operateTenantDialog.visible = true
    },
    getCheckedKeys(treeData) {
      forEach(treeData, (item) => {
        if (item.allocationNumber === 1 || item.flag === 4) {
          this.checkedMenuKeys.push(item.menuKey)
        }
        if (!isEmpty(item.children)) {
          this.getCheckedKeys(item.children)
        }
      })
    },
    async findTenantMenu() {
      // 查找租户菜单
      this.menuTreeLoading = true
      this.checkedMenuKeys = []
      this.checkedTreedata = []
      this.$refs.menuTree.setCheckedKeys([])
      const [err, res] = await tenantMenuApiService.getTenantMenuUnionMenuSortTree({
        tenantId: this.currentTenant.id,
      })
      this.menuTreeLoading = false
      if (!err) {
        this.checkedTreedata = res
        this.getCheckedKeys(this.checkedTreedata)
        this.$nextTick(() => {
          this.$refs.menuTree.setCheckedKeys(this.checkedMenuKeys)
        })
      }
    },
    menuTreeClick(data) {
      // 获取当前租户
      this.currentTenant = data
      this.findTenantMenu()
    },
    async findTenantTree() {
      // 获取租户菜单数据
      this.tenantTreeLoading = true
      const [err, res] = await tenantApiService.getList({
        maxResultCount: 99,
        skipCount: 0,
      })
      this.tenantTreeLoading = false
      if (!err) {
        this.tenantTree = filter(res.items, (item) => {
          return item.extraProperties.IsActive
        })
        if (!isEmpty(this.tenantTree)) {
          // 租户不为空
          this.currentTenant = this.tenantTree[0]
          this.findTenantMenu()
          this.$nextTick(() => {
            this.$refs.tenantTree.setCurrentKey(this.currentTenant.id)
          })
        }
      }
    },
  },
  created() {
    this.findTenantTree()
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
